import { buyoutYBIValidate } from "../../application/dtos/buyout_ybi_validate";

export class buyoutYBIEntity {
    constructor( data ){ // cuando se recive un objeto con propiedades indefinidas en vez de las propiedades definidad de un objeto
        this.data = data
    }

    isValid() {
        return buyoutYBIValidate(this);
    }
}